// removed by extract-text-webpack-plugin
module.exports = {"mod_default":"_38mar","folded":"_3iN13","buttonArrowLeft":"_2SIqQ _3rpFj","buttonArrowRight":"_3FCf- _3rpFj","button":"_3wM_H","buttonText":"_3BF0Z","buttonArrow":"_2KeRV","caret":"_3rpFj"};


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/Page/PageComponents/Fakta/styles.scss
 ** module id = 447
 ** module chunks = 0
 **/